/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { ListSectionSpinner, PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useEffect } from "react";
import { NotificationsTable } from "./NotificationsTable";
import { useNotifications } from "../../store/useNotifications";

function NotificationsScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const {
    getSentNotifications,
    sentNotifications,
    sentNotificationsLoading,
    sentNotificationsFetched,
    sentNotificationsError,
  } = useNotifications();

  /** Callbacks */
  const addNotification = () => navigate("/add-notification");

  useEffect(() => {
    getSentNotifications();
  }, []);

  // While anything is queued or being sent, refresh in place every 5 s so
  // the status badge and progress bar move. Stops on its own once every
  // row has settled.
  const hasActiveJob = sentNotifications?.some(
    (item) =>
      item?.status === "RUNNING" ||
      (item?.status === "PENDING" &&
        new Date(item?.scheduleDate ?? 0).getTime() <= Date.now() + 60_000)
  );
  useEffect(() => {
    if (!hasActiveJob) return;
    const timer = setInterval(() => getSentNotifications(true), 5000);
    return () => clearInterval(timer);
  }, [hasActiveJob]);

  const isLoading = sentNotificationsLoading || !sentNotificationsFetched;

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Notifications
        </h1>
        <PrimaryButton
          onClick={addNotification}
          label="Send notification"
          className="h-10"
        />
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {isLoading ? (
          <ListSectionSpinner label="Loading notifications" />
        ) : sentNotificationsError ? (
          <p className="text-center font-satoshi text-base text-red-500 py-12">
            {sentNotificationsError}
          </p>
        ) : !sentNotifications?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Notification created yet.
          </p>
        ) : (
          <NotificationsTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(NotificationsScreen);
